import PropTypes from 'prop-types'
import React from 'react'

import { Tooltip } from '@/components/ui/Tooltip'

/**
 *
 * RowActionButton
 *
 * WARP-939 — a row action in the Users table, with the hover label the icons were
 * missing. The actions column is unlabeled icons and keeps growing, so what each icon
 * does has to be readable without clicking it.
 *
 * `label` is both the hover text and the accessible name, so the two can never drift.
 */
const RowActionButton = ({ disabled, icon, label, onClick }) => (
  <Tooltip
    content={
      <div className="bg-charcoal-950 rounded-md px-2 py-1">
        <p className="text-sm text-white">{label}</p>
      </div>
    }
    placement="top"
  >
    <button
      aria-label={label}
      className="inline-flex items-center rounded-lg p-2 text-center hover:bg-gray-100 disabled:opacity-50"
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      {icon}
    </button>
  </Tooltip>
)

RowActionButton.defaultProps = {
  disabled: false,
}

RowActionButton.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default RowActionButton
